import { apiSlice } from "features/api/apiSlice";

const claimVoucher = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    claimVoucher: build.mutation({
      query: ({ code, id }) => ({
        url: "/vouchers/claim",
        method: "POST",
        body: { voucherCode: code, id },
      }),
      invalidatesTags: ["Voucher"],
    }),
  }),
});

export const { useClaimVoucherMutation } = claimVoucher;
